export enum QuotationPageTypeEnum {
    Cotacoes = 1,
    Vendedores = 2
}